import { Link } from 'react-router-dom';
import { Github, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-blue text-gray px-6 py-12 pb-1">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Branding */}
        <div>
          <h2 className="text-2xl font-bold text-gray">LangBridge</h2>
          <p className="mt-2 text-sm text-gray">
            Bridging the gap between languages — learn, quiz, and grow.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-white">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-purple transition">Home</Link></li>
            <li><Link to="/flashcards" className="hover:text-purple transition">Flashcards</Link></li>
            <li><Link to="/quiz" className="hover:text-purple transition">Quiz</Link></li>
            <li><Link to="/translate" className="hover:text-purple transition">Translate</Link></li>
            <li><Link to="/correct" className="hover:text-purple transition">Correct</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-white">Contact</h3>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Mail size={16} />
              <a href="mailto:support@langbridge.app" className="hover:text-blue-400 transition">
                support@langbridge.app
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Github size={16} />
              <a href="https://github.com/your-github/langbridge" target="_blank" rel="noreferrer" className="hover:text-blue-400 transition">
                GitHub Repo
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="mt-10  pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-neutral-500">
        <p>© {new Date().getFullYear()} LangBridge. All rights reserved.</p>
        
      </div>
    </footer>
  );
};

export default Footer;
